import {
  Button,
  Card,
  Table,
  Tooltip,
  Row,
  Col,
  DatePicker,
  Input,
  Switch,
  Select,
} from "antd";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import Plus from "../../assets/images/plus.svg";
import DeleteModal from "../../components/DeleteModal";
import apiPath from "../../constants/apiPath";
import { AppStateContext } from "../../context/AppContext";
import AddForm from "./AddFrom";
import { Severty, ShowToast } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import useRequest from "../../hooks/useRequest";
import { Label } from "recharts";
import { challengeCategory, challengeDuration } from "../../helper/functions";
import { values } from "lodash";
import { UndoOutlined } from "@ant-design/icons";
import { render } from "@testing-library/react";
import SendMediaForm from "../../modals/SendMediaForm";
import { useNavigate } from "react-router";

const { RangePicker } = DatePicker;

function Predefined() {
  const heading = "Challenge Manager";
  const { setPageHeading } = useContext(AppStateContext);
  const sectionName = "Challenge";

  const api = {
    addMedia: `${apiPath.getChallenges}/add-media`,
  };
  const navigate = useNavigate();

  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState();
  const [showDelete, setShowDelete] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const debouncedSearchText = useDebounce(searchText, 300);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [send, setSend] = useState(false);

  const [filter, setFilter] = useState({
    categoryf: undefined,
    durationf: undefined,
  });
  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: 10 });
  };

  const onDelete = (id) => {
    request({
      url: apiPath.deleteChallenge + "/" + id,
      method: "DELETE",
      onSuccess: (data) => {
        setLoading(false);
        setRefresh((prev) => !prev);
        ShowToast(data.message, Severty.SUCCESS);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChangeStatus = (id, message) => {
    request({
      url: apiPath.statusChallenge + "/" + id,
      method: "PUT",
      data: { message },
      onSuccess: (data) => {
        setLoading(false);
        setRefresh((prev) => !prev);
        ShowToast(data.message, Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a?.title?.localeCompare(b?.title),
      sortDirections: ["ascend", "descend"],
      render: (_, { title }) => {
        return title ? title : "-";
      },
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      sorter: (a, b) => a?.category?.localeCompare(b?.category),
      sortDirections: ["ascend", "descend"],
      render: (_, { category }) => {
        return category ? <span className="cap">{category}</span> : "-";
      },
    },

    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
      sorter: (a, b) => (a?.duration || 0) - (b?.duration || 0),
      sortDirections: ["ascend", "descend"],
      render: (_, { category, duration, start_date, end_date }) => {
        return duration ? (
          <span style={{ textTransform: "lowercase" }}>{duration} Days</span>
        ) : category == "seasonal" ? (
          <span>{new Date(start_date)?.toLocaleDateString() + " - " + new Date(end_date)?.toLocaleDateString()}</span>
        ) : (
          "-"
        );
      },
    },
    {
      title: "Emotion CheckIns",
      dataIndex: "emotion_checkins",
      key: "emotion_checkins",
      sorter: (a, b) => (a?.emotion_checkins || 0) - (b?.emotion_checkins || 0),
      sortDirections: ["ascend", "descend"],
      render: (_, { emotion_checkins }) => {
        return <span>{emotion_checkins ?? 0}</span>;
      },
    },
    {
      title: "used Count",
      dataIndex: "used_count",
      key: "used_count",
      sorter: (a, b) => (a?.used_count || 0) - (b?.used_count || 0),
      sortDirections: ["ascend", "descend"],
      render: (_, { used_count }) => {
        return <span>{used_count ?? 0}</span>;
      },
    },
    {
      title: "Finished Count",
      dataIndex: "finished_count",
      key: "finished_count",
      sorter: (a, b) => (a?.finished_count || 0) - (b?.finished_count || 0),
      sortDirections: ["ascend", "descend"],
      render: (_, { finished_count }) => {
        return finished_count ? (
          <span className="cap">{finished_count}</span>
        ) : (
          "0"
        );
      },
    },
    {
      title: "Dropped Count",
      dataIndex: "dropped_count",
      key: "dropped_count",
      sorter: (a, b) => (a?.dropped_count || 0) - (b?.dropped_count || 0),
      sortDirections: ["ascend", "descend"],
      render: (_, { dropped_count }) => {
        return dropped_count ? (
          <span className="cap">{dropped_count}</span>
        ) : (
          "0"
        );
      },
    },
    {
      title: "Status",
      key: "is_active",
      dataIndex: "is_active",
      className: "driver-status",
      render: (_, { _id, is_active }) => {
        return (
          <Switch
            onChange={() => {
              handleChangeStatus(_id);
            }}
            checked={is_active}
          />
        );
      },
      filters: [
        {
          text: "Active",
          value: true,
        },
        {
          text: "Inactive",
          value: false,
        },
      ],
    },
    {
      title: "Added On",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return moment(created_at).format("ll");
      },
    },
    {
      title: "Action",
      fixed: "right",
      key: "action",
      render: (_, record) => {
        return (
          <div div className="d-flex justify-contenbt-start">
            <Tooltip title={"View"} color={"purple"} key={"progress"}>
              <Button
                className="edit-cls btnStyle primary_btn"
                onClick={() => {
                  navigate(`/challenge/view-predefined/${record._id}`);
                }}
              >
                <i class="far fa-eye"></i>
              </Button>
            </Tooltip>

            <Tooltip title={"Send"} color={"purple"} key={"send"}>
              <Button
                className="edit-cls btnStyle primary_btn"
                onClick={() => {
                  setSelected(record);
                  setSend(true);
                }}
              >
                <i style={{ color: "fff" }} class="fa fa-paper-plane"></i>
              </Button>
            </Tooltip>
            <Tooltip title={"Edit"} color={"purple"} key={"edit"}>
              <Button
                className="edit-cls btnStyle primary_btn"
                onClick={() => {
                  setSelected(record);
                  setVisible(true);
                }}
              >
                <i style={{ color: "fff" }} class="far fa-edit"></i>
              </Button>
            </Tooltip>
            {/* <Tooltip title={"Delete"} color={"purple"} key={"Delete"}>
              <Button
                className="btnStyle deleteDangerbtn"
                onClick={() => {
                  setSelected(record);
                  setShowDelete(true);
                }}
              >
                <i
                  style={{ fontSize: "small", color: "fff" }}
                  class="fa fa-light fa-trash"
                ></i>
              </Button>
            </Tooltip> */}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    setLoading(true);
    fetchData({ ...pagination, current: 1 });
  }, [refresh, filter, debouncedSearchText, startDate, endDate]);

  useEffect(() => {
    setPageHeading(heading);
  }, [setPageHeading]);

  const fetchData = (pagination, filters, sorter) => {
    const filterActive = filters ? filters.is_active : null;
    const queryString = Object.entries(filter)
      .filter(([_, v]) => v != undefined)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    request({
      url:
        apiPath.getChallenges +
        `?type=Predefined&status=${filterActive ? filterActive.join(",") : ""
        }&page=${pagination ? (debouncedSearchText ? 1 : pagination.current) : 1
        }&limit=${pagination ? pagination.pageSize : 10
        }&search=${debouncedSearchText}${queryString ? `&${queryString}` : ""}${sorter ? `&${sorter}` : ""
        }`,
      method: "GET",
      onSuccess: ({ data }) => {
        setLoading(false);
        setList(data.docs);
        setPagination((prev) => ({
          ...prev,
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: data.totalDocs,
        }));
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);

        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChange = (pagination, filters, sorter) => {
    const { field, order } = sorter;
    console.log(sorter, "sorter");
    let query = undefined;
    if (field && order) {
      query = `${field}=${order}`;
      console.log(query, "query");
    }
    fetchData(pagination, filters, query);
  };

  const onChange = (key, value) => {
    setFilter((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <>
      <div className="tabled productCaralogue">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={"All Challenges"}
              extra={
                <>
                  <div className="button_group justify-content-end w-100">
                    <div className="role-wrap">
                      <Select
                        last20Years
                        showSearch
                        placeholder="Duration"
                        options={challengeDuration?.map((item) => ({
                          label: item?.name,
                          value: item?.value,
                        }))}
                        value={filter.durationf}
                        onChange={(value) => onChange("durationf", value)}
                      />
                    </div>
                    <div className="role-wrap">
                      <Select
                        last20Years
                        showSearch
                        placeholder="Category"
                        options={challengeCategory?.map((item) => ({
                          label: item?.name,
                          value: item?.value,
                        }))}
                        value={filter.categoryf}
                        onChange={(value) => onChange("categoryf", value)}
                      />
                    </div>
                    <Button
                      onClick={() => {
                        setFilter({
                          categoryf: undefined,
                          durationf: undefined,
                        });
                      }}
                      type="primary"
                      icon={<UndoOutlined />}
                    >
                      {"Reset"}
                    </Button>
                    <Button
                      className="primary_btn btnStyle"
                      onClick={(e) => {
                        setVisible(true);
                        setSearchText("");
                      }}
                    >
                      <span className="add-Ic">
                        <img src={Plus} />
                      </span>
                      {"Add"} {sectionName}
                    </Button>
                  </div>
                </>
              }
            >
              <div className="table-responsive customPagination">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      {visible && (
        <AddForm
          section={sectionName}
          api={api}
          show={visible}
          hide={() => {
            setSelected();
            setVisible(false);
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      {showDelete && (
        <DeleteModal
          title={"Delete Challenge"}
          subtitle={`Are you sure you want to delete this challenge?`}
          show={showDelete}
          hide={() => {
            setShowDelete(false);
            setSelected();
          }}
          onOk={() => onDelete(selected?._id)}
        />
      )}

      {showStatus && (
        <DeleteModal
          title={`${selected?.is_active ? `Block` : `UnBlock`} ${"User"}`}
          subtitle={`${"Are you sure you want to"} ${selected?.is_active ? `block` : `unblock`
            } ${"this user?"}`}
          show={showStatus}
          hide={() => {
            setShowStatus(false);
            setSelected();
          }}
          onOk={(message) => handleChangeStatus(selected?._id, message)}
        />
      )}

      {send && (
        <SendMediaForm
          show={send}
          section={"Media"}
          useFor={"Predefined"}
          api={api}
          hide={() => {
            setSend(false);
            setSelected();
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
    </>
  );
}

export default Predefined;
